import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 h-full overflow-auto flex flex-col" }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center gap-2 mb-3"
}
const _hoisted_3 = { class: "inline-flex items-center gap-1" }
const _hoisted_4 = { class: "inline-flex items-center gap-1" }
const _hoisted_5 = { class: "inline-flex items-center gap-1" }
const _hoisted_6 = {
  key: 0,
  class: "ml-2 w-64"
}
const _hoisted_7 = {
  key: 2,
  class: "overflow-auto flex-1 text-14px"
}
const _hoisted_8 = {
  key: 2,
  class: "flex items-center gap-2"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "text-black-lp-300 font-semibold line-clamp-2 w-50" }
const _hoisted_12 = { class: "flex flex-row items-center gap-1" }
const _hoisted_13 = { class: "text-12px text-gray-lp-300" }
const _hoisted_14 = {
  key: 3,
  class: "whitespace-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_TableDetail = _resolveComponent("TableDetail")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.INTERNAL_SERVER_ERROR,
          onTryAgain: _ctx.fetchData,
          textButtonSuccess: _ctx.$t('pickupDashboard.tryAgain')
        }, null, 8, ["errorType", "onTryAgain", "textButtonSuccess"]))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("button", {
            class: _ctx.pillClass(_ctx.activePill === 'today'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPill('today')))
          }, [
            _createVNode("span", _hoisted_3, [
              (_ctx.activePill === 'today')
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require('@/app/ui/assets/svg/check-circle-red.svg'),
                    class: "w-4 h-4",
                    alt: "check-circle-red"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.today")), 1)
            ])
          ], 2),
          _createVNode("button", {
            class: _ctx.pillClass(_ctx.activePill === 'yesterday'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPill('yesterday')))
          }, [
            _createVNode("span", _hoisted_4, [
              (_ctx.activePill === 'yesterday')
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require('@/app/ui/assets/svg/check-circle-red.svg'),
                    class: "w-4 h-4",
                    alt: "check-circle-red"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.yesterday")), 1)
            ])
          ], 2),
          _createVNode("button", {
            class: _ctx.pillClass(_ctx.activePill === 'custom'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPill('custom')))
          }, [
            _createVNode("span", _hoisted_5, [
              (_ctx.activePill === 'custom')
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require('@/app/ui/assets/svg/check-circle-red.svg'),
                    class: "w-4 h-4",
                    alt: "check-circle-red"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.custom")), 1)
            ])
          ], 2),
          (_ctx.activePill === 'custom')
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_DatePickerV2, {
                  modelValue: _ctx.startDateStr,
                  onSelected: _ctx.onSelectCustomDate,
                  minDate: null,
                  showDatePicker: true,
                  showTimePicker: false,
                  placeholder: _ctx.$t('pickupDashboard.selectDate'),
                  dateFormat: 'dd M yy',
                  locale: {
            firstDayOfWeek: 1,
            dayNamesMin: ['Mi', 'Se', 'Ra', 'Ka', 'Ju', 'Sa', 'Mg'],
            monthNamesShort: [
              'jan',
              'feb',
              'mar',
              'apr',
              'mei',
              'jun',
              'jul',
              'agu',
              'sep',
              'okt',
              'nov',
              'des'
            ]
          },
                  showIcon: true,
                  showChevron: true
                }, null, 8, ["modelValue", "onSelected", "placeholder"])
              ]))
            : _createCommentVNode("", true)
        ])),
    (!_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_TableDetail, {
            columns: _ctx.columns,
            data: _ctx.pagedData,
            isLoading: _ctx.isLoading,
            sortBy: _ctx.sortBy,
            sortDir: _ctx.sortDir,
            startIndex: _ctx.startIndex,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => (_ctx.pagination = $event)),
            renderedData: _ctx.pagedData.length,
            isFiltering: _ctx.isFiltering,
            onSetPage: _ctx.onSetPage,
            onSort: _ctx.onSort,
            heightOffset: 20
          }, {
            cell: _withCtx(({ item, col }) => [
              (col.key === 'stt_no')
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    class: "text-red-lp-100 underline cursor-pointer",
                    onClick: ($event: any) => (_ctx.openTracking(item.stt_no))
                  }, _toDisplayString(item.stt_no || "-"), 9, ["onClick"]))
                : (col.key === 'shipment_id')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(item.shipment_id || "-"), 1)
                    ], 64))
                  : (col.key === 'sender_name')
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        (!item.sender_name)
                          ? (_openBlock(), _createBlock("div", _hoisted_9, "-"))
                          : (_openBlock(), _createBlock("div", _hoisted_10, [
                              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.ellipsis(item.sender_name || "-")), 1),
                              _createVNode("div", _hoisted_12, [
                                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatPhoneNumber(item.sender_phone) || "-"), 1),
                                _createVNode("img", {
                                  src: 
                      require('@/app/ui/assets/svg/ics_o_whatsapp-background.svg')
                    ,
                                  class: "w-4 h-4 cursor-pointer",
                                  alt: "whatsapp",
                                  onClick: ($event: any) => (_ctx.onOpenWa(item.sender_phone))
                                }, null, 8, ["src", "onClick"])
                              ])
                            ]))
                      ]))
                    : (col.key === 'shipment_type')
                      ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.formatShipmentType(item.shipment_type)), 1))
                      : (col.key === 'total_quantity')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(_ctx.fmtQty(item.total_quantity)), 1)
                          ], 64))
                        : (col.key === 'status_at')
                          ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(item.status_at)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "data", "isLoading", "sortBy", "sortDir", "startIndex", "pagination", "renderedData", "isFiltering", "onSetPage", "onSort"])
        ]))
      : _createCommentVNode("", true)
  ]))
}